import { render } from "./SubHeader.vue?vue&type=template&id=5df2eab6&scoped=true&ts=true"
import script from "./SubHeader.vue?vue&type=script&lang=ts"
export * from "./SubHeader.vue?vue&type=script&lang=ts"

import "./SubHeader.vue?vue&type=style&index=0&id=5df2eab6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df2eab6"]])

export default __exports__